import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';

const baseQueryWithReAuth = createBaseQuery('user');

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    // Authentication endpoints
    login: builder.mutation({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: credentials
      })
    }),
    register: builder.mutation({
      query: (userData) => ({
        url: '/register',
        method: 'POST',
        body: userData
      })
    }),
    temporaryPasswordResetRequest: builder.mutation({
      query: (params) => ({
        url: '/reset-password-request',
        method: 'POST',
        body: params
      })
    }),
    temporaryPasswordReset: builder.mutation({
      query: (params) => ({
        url: '/initial-password-reset',
        method: 'POST',
        body: params
      })
    }),
    passwordResetRequest: builder.mutation({
      query: (params) => ({
        url: '/reset-password',
        method: 'POST',
        body: params
      })
    }),

    // User management endpoints
    manageUserStatus: builder.mutation({
      query: (params) => ({
        url: '/users',
        method: 'PUT',
        body: params
      }),
      invalidatesTags: ['UserList']
    }),
    getUserList: builder.query({
      query: ({ page, limit, sortBy, sortOrder, filters }) => ({
        url: '/user-list',
        method: 'POST',
        body: {
          page,
          limit,
          sortBy: sortBy || 'createdAt',
          sortOrder: sortOrder || 'DESC',
          filters: filters || {}
        }
      }),
      providesTags: ['UserList'],
      keepUnusedDataFor: 0
    }),
    getRolesList: builder.query({
      query: () => ({
        url: '/roles-list',
        method: 'GET'
      })
    }),
    getPrivilegesList: builder.query({
      query: () => ({
        url: '/privilege-list',
        method: 'GET'
      })
    }),
    checkAvailability: builder.query({
      query: ({ type, value }) => ({
        url: '/check-availability',
        method: 'POST',
        body: { type, value }
      })
    })
  })
});

export const {
  useTemporaryPasswordResetRequestMutation,
  useTemporaryPasswordResetMutation,
  usePasswordResetRequestMutation,
  useManageUserStatusMutation,
  useGetPrivilegesListQuery,
  useCheckAvailabilityQuery,
  useGetRolesListQuery,
  useRegisterMutation,
  useGetUserListQuery,
  useLoginMutation
} = apiSlice;

export const checkAvailabilityDirect = async (dispatch, { type, value }) => {
  const result = await dispatch(apiSlice.endpoints.checkAvailability.initiate({ type, value }));
  return result.data;
};
